import React from "react";
import { Layout, Row, Col } from "antd";

import { FOOTER_ID } from "../../constants";
import styles from "./footer.scss";
import { isMobileScreen } from "../../services";
import { Logo } from "./Logo";
import { Copyright } from "./Copyright";
import { ContactSection } from "./ContactSection";
import { HelpSectionDesktop } from "./HelpSectionDesktop";
import { HelpSectionMobile } from "./HelpSectionMobile";
import getWidthContext from "../../HOCs/getWidthContext";

function Footer({ width }) {
  const mobile = isMobileScreen(width);
  return (
    <Layout.Footer id={FOOTER_ID} className={styles.container}>
      <div className={styles.footer}>
        <Row type="flex" justify="space-between">
          <Col
            xs={24}
            sm={24}
            md={4}
            lg={4}
            xl={4}
            className={styles.logoColumn}
          >
            <Logo />
          </Col>

          <Col
            xs={24}
            sm={24}
            md={24}
            lg={8}
            xl={8}
            className={styles.contactColumn}
          >
            <ContactSection className={styles.contactSection} />
          </Col>

          <Col
            xs={24}
            sm={24}
            md={12}
            lg={10}
            xl={10}
            className={styles.helpColumn}
          >
            {!mobile ? <HelpSectionDesktop /> : <HelpSectionMobile />}
          </Col>
        </Row>

        <Copyright className={styles.copyrightColumn} />
      </div>
    </Layout.Footer>
  );
}

export default React.memo(getWidthContext(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx